// T-281 — Logica PURA per le stampanti device-local (niente Capacitor/DOM →
// testabile in node). Una stampante è una periferica del DISPOSITIVO (indirizzo
// BLE / nome QZ / driver Windows): vive sul dispositivo, disponibile in TUTTI i
// locali, non è un dato multi-tenant. Vedi devicePrinters.ts per l'I/O.

import type { PrinterConnection, PrinterDriver } from '@trackeat/shared';

export interface DevicePrinter {
  id: string;
  name: string;
  driver: PrinterDriver;
  connection: PrinterConnection;
  address: string;
  label_size_mm: { width: number; height: number };
  dpi: number;
}

export interface DevicePrinterStore {
  printers: DevicePrinter[];
  defaultId: string | null;
}

export const EMPTY_STORE: DevicePrinterStore = { printers: [], defaultId: null };

interface PrinterLike {
  id: string;
  driver: string;
}

/**
 * Stampante da pre-selezionare in ogni sezione che stampa.
 * Priorità: (1) la predefinita esplicita se esiste ancora (anche se è
 * l'anteprima — scelta consapevole dell'utente); (2) la prima stampante reale
 * (non anteprima); (3) l'anteprima come ultima spiaggia.
 */
export function resolveDefaultPrinterId(
  printers: PrinterLike[],
  storedDefaultId: string | null,
  previewId: string,
): string {
  if (storedDefaultId && printers.some((p) => p.id === storedDefaultId)) {
    return storedDefaultId;
  }
  const firstReal = printers.find((p) => p.driver !== 'preview');
  if (firstReal) return firstReal.id;
  return previewId;
}
